"use client"

import { queryClient } from "@/shared/utils/query-client"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { type PropsWithChildren } from "react"
import { Toaster } from "react-hot-toast"

import "../utils/logs"

type ProvidersProps = PropsWithChildren

export const Providers = ({ children }: ProvidersProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
      <Toaster position="top-center" />
    </QueryClientProvider>
  )
}
